export const cellValueIsKiz = (cells: IGridCell[]): boolean => {
    const Yes = 'Да'
    let kizStatus = cells.find(x => x.propertyName == 'isKiz')?.value as string
    if (kizStatus === Yes) {
        return true
    } else {
        return false
    }
}